<div class="workSpace">
  <!-- Titulo -->
  <div class="w3-container w3-container-template headersTab">
    <!--Titulo de modulo y subtitulo-->
    <div class="w3-caja-menu padreizquierda">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate }} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }} </span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-margin-left-filter w3-subtituloPrincipal"> {{ plantilla ? plantilla.nombreInst : '' }} </span>
      </div>
    </div>
  </div>
  <!-- TABLERO -->
  <div class="w3-row workSpaceTab" style="display: flex; justify-content: center; align-items: center;">
    <div class="w3-row">
      <!-- Seleccion plantilla -->
      <div class="w3-row ">
        @if(plantilla){
          <div class="w3-veinte w3-center" style="width: fit-content; margin-left: 5px;">
            <span class="status-badge" [ngClass]="plantilla.activo ? 'activo' : 'inactivo'">
              {{ plantilla.activo ? 'Activa' : 'Inactiva' }}
            </span>
          </div>          
        }  
        <div class="w3-half">
          <app-select-title
            [options]="dataPlantillas"
            [placeholder]="'proyFinanciera.configCatalogo.selecPlanti'"
            displayKey="nombre"
            (selectedChange)="selectPlantilla($event)"       
          ></app-select-title>
        </div>
       
      </div>
      <!-- Tabla indicador -->
      <div class="w3-white w3-row conteTabla">
        <div class="w3-row w3-right" >
          <div class="w3-row w3-half w3-titulo-contenidomenuSC padreizquierda">
            <div class="w3-noventa2 hijoizquierdaTitle">
              <span class="w3-margin-left-contenido">{{'proyFinanciera.configIndicador.titTab' | translate}}</span>
            </div>
          </div>
          <div class="w3-rest colorBotonDeNuevo w3-right" style="margin-top: 15px; margin-bottom: 5px;" (click)="modalIndicador()">
            {{'proyFinanciera.configIndicador.agregarIndi' | translate}}
            <mat-icon class="iconoMen">add_circle_outline</mat-icon>
          </div>
        </div>
        <div class="w3-scroll" style="height: 88%; margin-bottom: 1%;">
          <table class="w3-table">
            <thead>
              <tr class="w3-table-titleLow w3-center">
                @if(universo){<th class="w3-border-right-balance marginsH stikyColum" matTooltip="{{'swal.seleccionarTodo' | translate}}" style="width: 20px;"> 
                  <mat-checkbox [(ngModel)]="selectAll" (change)="seleccionarTodos()" color="warn"></mat-checkbox>
                </th>}
                <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configIndicador.titTab1' | translate}} </th>
                <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configIndicador.titTab2' | translate}} </th>
                <th class="w3-border-right-balance marginsH stikyColum"> {{'proyFinanciera.configIndicador.titTab3' | translate}} </th>
                @if(!universo){<th class="w3-border-right-balance marginsH stikyColum">  </th>}
              </tr>
            </thead>
            @for (d of indicadores; track $index) {
              <tbody>
                <tr class="w3-table-trtd">
                  @if(universo){
                    <td class="borderAllLow marginsH">
                      <mat-checkbox color="warm" [(ngModel)]="d.selected" (change)="checkSeleccionados()"></mat-checkbox>
                    </td>
                  }
                  <td class="borderAllLow marginsH">{{getGrupoNombre(d.grupoid)}}</td>
                  <td class="borderAllLow marginsH">{{d.indicador}}</td>
                  <td class="borderAllLow marginsH">{{d.descripcion}}</td>
                  @if(!universo){
                    <td class="borderAllLow marginsH w3-center">
                      <mat-icon class="iconoMen material-icons-outlined" matTooltip="{{'proyFinanciera.configIndicador.setInd' | translate}}"
                        (click)="configurarIndicador(d)">settings</mat-icon>
                    </td>
                  }                  
                </tr>
              </tbody>
            } 
          </table>
        </div>
        <div class="w3-row">
          <div class="w3-right">
            <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="vincularIndicadores()">{{'acciones.guard' | translate}}</button>
          </div>         
        </div>
      </div> 
    </div>       
  </div>
</div>

<!-- Modal configuracion de indicador -->
<div id="indicador" class="modal" (click)="clickFuera($event, 'nuevaPlantilla')">
  <div class="modal-content" style="width: 70vw; height: 90vh;">
    <div class="w3-row">
      <div class="w3-row w3-half w3-titulo-contenidomenuG padreizquierda" style="margin-left: 30px; margin-top: 8px;">
        {{tituloModal}}
      </div>
      <div class="w3-rest">
        <mat-icon (click)="closeModal()" matTooltip="{{ 'gestion.seguimiento.estrategias.cerrar' | translate }}" class="w3-button w3-display-topright"
          style="margin-top: 8px;margin-right: 24px;">clear</mat-icon>
      </div>
    </div>    
    <div class="w3-row w3-center w3-scroll" style="margin: 1vh;">
      <form [formGroup]="formIndicador" (ngSubmit)="guardarIndicador()" id="formIndicador">      
        <div class="w3-row ">
          <div class="w3-row w3-quarter_e alinLeft marginsH" style=" width: 14%!important;">{{'proyFinanciera.configIndicador.grupo' | translate}}</div>
          <div class="w3-half alinLeft">
            <mat-form-field appearance="outline"  color="warn" style="height: 60px!important;">
              <mat-select formControlName="grupo" placeholder="{{'proyFinanciera.configIndicador.selecGrupo' | translate}}">
                @for (g of grupos; track $index) {<mat-option [value]="g">{{g.nombre}}</mat-option>}
              </mat-select>
            </mat-form-field>
          </div>
          @if(nuevoInd){
            <div class="w3-rest colorBotonDeNuevo w3-right" style="margin-top: 15px; margin-bottom: 5px; margin-right: 15px;" (click)="nuevoGrupo()">
              {{'proyFinanciera.configIndicador.agregarGrupo' | translate}}
              <mat-icon class="iconoMen">add_circle_outline</mat-icon>
            </div>
          }          
        </div>        
        <div class="w3-row campoForm">
          <div class="w3-row w3-quarter_e alinLeft marginsH" style="margin-top: 2%; width: 14%!important;">{{'proyFinanciera.configIndicador.nombre' | translate}}</div>
          <div class="w3-rest alinLeft">
            <mat-form-field appearance="outline" color="warn" class="field-input" style="width: 30vw;">
              <input matInput placeholder="Nombre" formControlName="indicador">
            </mat-form-field>
          </div>
        </div>
        <div class="w3-row campoForm">
          <div class="w3-row w3-quarter_e alinLeft marginsH" style="margin-top: 2%; width: 14%!important;">{{'proyFinanciera.configIndicador.descrip' | translate}}</div>
          <div class="w3-rest alinLeft">
            <mat-form-field appearance="outline" color="warn" class="field-textArea">
              <textarea matInput placeholder="Descripción" style="resize: none;" formControlName="descripcion"></textarea>
            </mat-form-field>
          </div>
        </div>
        <!-- Formula -->
        <div class="w3-row" style="margin: 5px; font-weight: 500; text-align: left;">{{'proyFinanciera.configIndicador.formula' | translate}}</div>
        <div class="w3-row">
          <table>
            <tbody>
              <tr class="w3-table-trtd" style="color: black; font-size: 14px;">
                <td></td>
                <td>{{'proyFinanciera.configIndicador.codigo' | translate}}</td>
                <td>{{'proyFinanciera.configIndicador.cuenta' | translate}}</td>
              </tr>
              <tr class="w3-table-trtd" style="color: black; font-size: 14px;">
                <td class="marginsH">{{'proyFinanciera.configIndicador.numerador' | translate}}</td>
                <td class="borderAllLow marginsH" style="width: 20vw;">
                  <input id="numerador" type="text" formControlName="numerador" placeholder="{{'proyFinanciera.configIndicador.ejNum' | translate}}"
                    class="inputPon" style="color: black; font-size: 14px;" autocomplete="off"/>
                  <!-- Mensajes de error -->
                  @if (formIndicador.get('numerador')?.errors; as errors) {
                    <div class="text-red-500 text-sm mt-1">
                      @switch (true) {
                        @case (errors['invalidCharacter']) {
                          {{ 'proyFinanciera.configIndicador.caracterInv' | translate }}
                        }
                        @case (errors['unbalancedParentheses']) {
                          {{ 'proyFinanciera.configIndicador.noParentesis' | translate }}
                        }
                        @case (errors['invalidOperatorSequence']) {
                          {{ 'proyFinanciera.configIndicador.secuenciaInv' | translate }}
                        }
                      }
                    </div>
                  }
                </td>
                <td  class="borderAllLow marginsH" style="width: 25vw;">
                  <input class="inputPon" style="resize: none; color: black; font-size: 14px;" type="text" formControlName="cuentaNum" placeholder="{{'proyFinanciera.configIndicador.ejCuentaNum' | translate}}">
                </td>
              </tr>
              <tr class="w3-table-trtd" style="color: black; font-size: 14px;">
                <td class="marginsH">{{'proyFinanciera.configIndicador.denominador' | translate}}</td>
                <td class="borderAllLow marginsH">
                  <input id="denominador" style="color: black; font-size: 14px;" type="text" formControlName="denominador" placeholder="{{'proyFinanciera.configIndicador.ejDeno' | translate}}"
                    class="inputPon" autocomplete="off"/>
                  <!-- Mensajes de error -->
                  @if (formIndicador.get('denominador')?.errors; as errors) {
                    <div class="text-red-500 text-sm mt-1">
                      @switch (true) {
                        @case (errors['invalidCharacter']) {
                          {{ 'proyFinanciera.configIndicador.caracterInv' | translate }}
                        }
                        @case (errors['unbalancedParentheses']) {
                          {{ 'proyFinanciera.configIndicador.noParentesis' | translate }}
                        }
                        @case (errors['invalidOperatorSequence']) {
                          {{ 'proyFinanciera.configIndicador.secuenciaInv' | translate }}
                        }
                      }
                    </div>
                  }
                </td>
                <td  class="borderAllLow marginsH" style="width: 25vw; line-height: 1.5;">
                  <textarea class="inputPon" style="resize: none; color:black; font-size: 14px;" type="text" formControlName="cuentaDen" placeholder="{{'proyFinanciera.configIndicador.ejCuentaDeno' | translate}}"></textarea>
                </td>
              </tr>
            </tbody>
          </table>
          @if (formIndicador.get('numerador')?.errors?.['codigoInvalido']; as errores) {
            <div class="text-red-500 text-sm mt-1">
              {{'proyFinanciera.configIndicador.cuentasInv' | translate}} {{ errores.join(', ') }}
            </div>
          }
        </div> 
        <!-- Semaforos -->
        <div class="w3-row" style="margin: 5px; font-weight: 500; text-align: left;">{{'proyFinanciera.configIndicador.semaforo' | translate}}</div>
        <div class="w3-row w3-margin-top alinLeft" style="display: flex; flex-direction: row; margin-bottom: 15px;">
          <div style="width: 90px; margin-left: 15px;">{{ 'proyFinanciera.configIndicador.numSemaforos' | translate }}</div>
          <mat-select placeholder="{{ 'Seleccione' | translate }}" matTooltip="{{ 'Seleccione' | translate }}"  style="width: 100px; border: 1px; " (selectionChange)="numeroSemaforos($event.value)" [(value)]="numSemaforosSeleccionado">
            @for (n of [3,4,5,6]; track $index) {<mat-option [value]="n">{{ n }}</mat-option>}
          </mat-select>
          <div style="width: 70px; margin-left: 150px;">{{ 'proyFinanciera.configIndicador.limInf' | translate }}</div>
          <input matInput formControlName="limiteinferior" type="number" style="width: 100px; height: 30px;" autocomplete="off">
          <div style="width: 70px; margin-left: 15px;">{{ 'proyFinanciera.configIndicador.limSup' | translate }}</div>
          <input matInput formControlName="limitesuperior" type="number" style="width: 100px; height: 30px;" autocomplete="off">
        </div>
        <div formArrayName="semaforos" class="w3-row">
          @for (semaforo of semaforos.controls; track semaforo; let i = $index) {
            <div [formGroupName]="i" class="w3-row w3-padding-small" style="align-items: center; display: flex; gap: 12px; margin-bottom: 10px;">
              <!-- Número -->
              <div style="width: 80px; text-align: center;">Semáforo {{ i + 1 }}</div>
              <!-- Selector de color -->
              <div matTooltip="{{'proyFinanciera.configIndicador.SelecColor' | translate}}">
                <input type="color" formControlName="color" style="width: 20px; height: 20px; border: 0px solid rgba(128, 128, 128, 0); border-radius: 15px; cursor: pointer;">
              </div>
              <!-- Condición 1 -->
              <div style="display: flex; align-items: center; gap: 5px;">
                <mat-select formControlName="condicion1_operador" style="width: 100px;">
                  <mat-option value="<">&lt;</mat-option>
                  <mat-option value="<=">&le;</mat-option>
                  <mat-option value=">">&gt;</mat-option>
                  <mat-option value=">=">&ge;</mat-option>
                  <mat-option value="=">=</mat-option>
                </mat-select>
                <input matInput formControlName="condicion1_valor" type="number" style="width: 100px;" autocomplete="off">
              </div>
              <!-- Operador lógico -->
              <div>
                  <mat-select formControlName="operador_logico" style="width: 100px;">
                    <mat-option value="">—</mat-option>
                    <mat-option value="AND">AND</mat-option>
                    <mat-option value="OR">OR</mat-option>
                  </mat-select>
              </div>
              <!-- Condición 2 (solo si hay operador lógico) -->
              @if(semaforo.get('operador_logico')?.value){
                <div style="display: flex; align-items: center; gap: 5px;">
                  <mat-select formControlName="condicion2_operador" style="width: 100px;">
                    <mat-option value="<">&lt;</mat-option>
                    <mat-option value="<=">&le;</mat-option>
                    <mat-option value=">">&gt;</mat-option>
                    <mat-option value=">=">&ge;</mat-option>
                    <mat-option value="=">=</mat-option>
                  </mat-select>
                  <input matInput formControlName="condicion2_valor" type="number" style="width: 100px;" autocomplete="off">
                </div>
              }              
            </div>
          }
        </div>
        <!-- Boton guardar -->
        <div class="w3-row w3-center" style="margin-top: 4vh;">
          <button mat-flat-button color="success" style="height: 5vh; width: 30%;" [disabled]="formIndicador.invalid" [ngClass]="{'w3-disabled': formIndicador.invalid}">{{'acciones.guard' | translate}}</button>
        </div>
      </form>
    </div>
  </div>

</div>